"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactQuery = require("react-query");
var _core = require("@folio/stripes/core");
var _utils = require("../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useRefdata = _ref => {
  let {
    endpoint,
    desc,
    options = _utils.refdataOptions,
    queryParams,
    returnQueryObject = false
  } = _ref;
  const ky = (0, _core.useOkapiKy)();
  const nsValues = {};

  /* Desc will tend to contain a '.', which will throw off generateKiwtQuery.
   * To combat this we can insert another Desc. at the beginning to act as the filtername, so
   * Funder.Name => Desc.desc=Funder.Name. This way "Desc" acts as the filterName, and without a filterKey
   * "desc=Funder.Name" is passed wholesale to the query.
   */

  if (Array.isArray(desc)) {
    // If we have an array, append a desc filter for each desc given
    nsValues.filters = desc.map(d => `DescKey.${d}`).join(',');
  } else if (desc) {
    // If we just have a string, append a single desc filter
    nsValues.filters = `DescKey.${desc}`;
  }
  const query = (0, _utils.generateKiwtQuery)(options, nsValues);
  const path = `${endpoint}${query}`;
  const queryObject = (0, _reactQuery.useQuery)((0, _utils.refdataQueryKey)(desc), () => ky(path).json(), queryParams);
  if (returnQueryObject) {
    return queryObject || {};
  }
  const {
    data: refdata
  } = queryObject;
  return refdata || [];
};
useRefdata.propTypes = {
  endpoint: _propTypes.default.string,
  desc: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
  queryParams: _propTypes.default.object,
  returnQueryObject: _propTypes.default.bool
};
var _default = exports.default = useRefdata;